class WageAdvanceFormController {

  constructor(EventEmitter, $scope) {
    'ngInject';
    this.eventEmitter = EventEmitter;
    this.scope = $scope;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
      this.setFloatingActionButtonsDisabled();
    }
  }

  submit() {
    this.onSubmit(this.eventEmitter(this.getFormData()));
  }

  getFormData() {
    return {
      wageAdvanceAmount: this.wageAdvanceAmount,
      wageAdvanceReason: this.wageAdvanceReason,
      wageAdvanceOption: this.wageAdvanceOption,
    };
  }

  onSelectWageAdvanceReason($event) {
    this.wageAdvanceReason = $event.$item.value;
    this.wageAdvanceOption = $event.$item.option;
  }

  wageAdvanceReasonsListIsDisabled() {
    return !this.wageAdvanceReasonsList || this.wageAdvanceReasonsList.length === 0;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'LOANS.WAGE_ADVANCE.FORM.ASK',
        disabled: true
      }
    ];
  }

  setFloatingActionButtonsDisabled() {
    this.scope.$watch(() => this.form.$invalid, newValue => {
      this.floatingActionButtons[0].disabled=newValue;
    });
  }

  onKeyPressEnter($event){
    if($event.keyCode === 13){
      $event.target.blur();
    }
  }

}

export default WageAdvanceFormController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceForm/wageAdvanceForm.controller.js